// Bootstrap（volt.js や Stimulus 内の `bootstrap.*` が参照するためグローバルに公開）
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap

// ------------ Volt で使われているライブラリ ------------ //

// SweetAlert2
import Swal from 'sweetalert2'
window.Swal = Swal

// SmoothScroll
import SmoothScroll from 'smooth-scroll'
window.SmoothScroll = SmoothScroll

// Volt
import "../volt.js"

// Choices.js
import Choices from "choices.js"
import "choices.js/public/assets/styles/choices.min.css";

// Hotwire
import "../controllers";
import * as Turbo from "@hotwired/turbo";

// turbo frame 内でページ全体をリダイレクトさせる処理
import '../src/turbo_redirect_custom'

Turbo.start();

// Turboを無効化して必要なelementにdata-turbo="true"を追加する
Turbo.session.drive = false;
